import React from 'react';

import { SimpleIcon } from './icon-utils';

export function FolderSyncedIcon(): JSX.Element {
  return (
    <SimpleIcon fill="none" height="18" viewBoxDimensions="0 0 18 18" width="18">
      <path
        d="M15.1807 11.247L15.936 8.67225C16.218 7.7115 15.498 6.75 14.4968 6.75H7.116C6.45375 6.75 5.8695 7.18425 5.679 7.8195L3.93375 13.6372C3.825 14.001 3.48975 14.25 3.11025 14.25V14.25C2.63475 14.25 2.25 13.8652 2.25 13.3897V3.75C2.25 2.92125 2.92125 2.25 3.75 2.25H7.09875C7.34925 2.25 7.58325 2.37525 7.72275 2.5845L8.77725 4.16625C8.916 4.37475 9.15075 4.5 9.40125 4.5H12.75C13.5788 4.5 14.25 5.17125 14.25 6V6.75"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.1948 14.25H3.1123"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.875 12.375L12 14.25L10.875 13.125"
        stroke="#00954D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.375 16.5C10.5113 16.5 9 14.9887 9 13.125C9 11.2613 10.5113 9.75 12.375 9.75C14.2395 9.75 15.75 11.2613 15.75 13.125C15.75 14.9887 14.2395 16.5 12.375 16.5"
        stroke="#00954D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
